// Display helpers shared by the pages. Dates are in the active language (i18n/format.ts).
export { formatAgo as ago, formatDay as day, formatDayMonth as dayMonth } from "../i18n";

/** The first and last characters of a long identifier, for a compact label. */
export function shortId(id: string): string {
  return id.length <= 12 ? id : `${id.slice(0, 6)}…${id.slice(-4)}`;
}
